import { RESET_ADMIN_USERS } from 'constants/action_types'
import { RESET_KEYWORD_LISTS } from './keywords/keyword_lists'
import { RESET_PRODUCT_COSTS } from './product_costs'
import { RESET_PROFIT_AND_LOSS } from './sales_analytics/profit_and_loss'
import { RESET_EXPENSES } from './sales_analytics/expenses'
import { RESET_INVENTORY_FORECAST } from './inventory/inventory_forecast'
import { RESET_ACADEMY } from './academy'
import { RESET_API_KEY } from './api_keys'

export const RESET_PAGES = [
  RESET_KEYWORD_LISTS,
  RESET_PRODUCT_COSTS,
  RESET_PROFIT_AND_LOSS,
  RESET_EXPENSES,
  RESET_INVENTORY_FORECAST,
  RESET_ADMIN_USERS,
  RESET_ACADEMY,
  RESET_API_KEY
]
